import * as Yup from 'yup';

export const addressValidationSchema = Yup.object().shape({
  name: Yup.string().min(1).max(128).required(),
  nickName: Yup.string().max(128),
  company: Yup.string().max(128),
  address: Yup.string().max(34, 'Address should be max 34 characters'),
  address2: Yup.string().max(34, 'Address 2 should be max 34 characters'),
  city: Yup.string().required().max(48),
  state: Yup.string().required('Please select state'),
  zip: Yup.object().shape({
    code: Yup.string().zipCode().nullable().required(),
  }),
  phoneNumber: Yup.string().phone(),
});
